<template>
  <div v-if="currentProfile">
    <v-layout row wrap align-center style="max-width: 1920px; margin: auto">
      <v-flex xs12>
        <v-layout
          row
          wrap
          justify-space-between
          class="supplierPageContent"
          :style="`padding: 0 ${
            $vuetify.breakpoint.smAndDown
              ? '20px;'
              : $vuetify.breakpoint.xl
              ? '20px;'
              : '80px'
          }`"
        >
          <v-flex xs12 v-if="breadcrumbItems.length > 0">
            <v-container>
              <!-- <v-breadcrumbs
                divider=">"
                :items="breadcrumbItems"
              ></v-breadcrumbs> -->
              <span
                class="primary--text"
                @click="$router.push(bc.href)"
                v-for="(bc, index) in breadcrumbItems"
                :key="`bc_${index}`"
              >
                {{ bc.text }}
                <span v-if="index < breadcrumbItems.length - 1" class="mx-2">
                  ></span
                >
              </span>
            </v-container>
          </v-flex>
          <v-flex xs12 v-if="$vuetify.breakpoint.mdAndDown">
            <div>
              <v-img :src="currentProfile.logoUrl" max-width="600">
                <template v-slot:placeholder>
                  <v-img
                    src="https://upstreamnz.s3.ap-southeast-2.amazonaws.com/impactBuyerBadges/Approved+Supplier+Badge-01.svg"
                    width="166"
                    height="166"
                    class="mx-auto"
                  ></v-img>
                </template>
              </v-img>
            </div>
          </v-flex>
          <v-flex md6 v-else>
            <div>
              <v-img :src="currentProfile.logoUrl" max-width="300">
                <template v-slot:placeholder>
                  <v-img
                    src="https://upstreamnz.s3.ap-southeast-2.amazonaws.com/impactBuyerBadges/Approved+Supplier+Badge-01.svg"
                    width="166"
                    height="166"
                    class="mx-auto"
                  ></v-img>
                </template>
              </v-img>
            </div>
          </v-flex>
          <!--UPSTREAM CONTRIBUTION-->
          <!--Upstream Contribution Mobile-->
          <v-flex v-if="$vuetify.breakpoint.smAndDown" xs12>
            <v-layout row wrap align-center justify-center>
              <v-flex shrink>
                <v-icon
                  color="#4dc8ed"
                  class="contributionIconMobile pr-3"
                  style="font-size: 50px !important"
                  >mdi-charity</v-icon
                >
              </v-flex>

              <v-flex>
                <div>
                  <h3
                    style="font-size: 23px !important"
                    class="heading font-weight-bold mb-0"
                  >
                    Upstream Contribution
                  </h3>
                  <p class="general-color font-weight-bold mb-3">
                    {{ currentProfile.contributionDetails }}
                  </p>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <!--Upstream Contribution Desktop-->
          <v-flex v-else xs12 md6>
            <v-layout row class="contributionSection" v-if="currentProfile">
              <v-icon color="#4dc8ed" class="contributionIcon mr-3"
                >mdi-charity</v-icon
              >
              <div style="display: inline" class="heading">
                <h3 style="font-size: 26px !important">
                  Upstream Contribution
                </h3>

                <p class="general-color font-weight-bold">
                  {{ currentProfile.contributionDetails }}
                </p>
              </div>
            </v-layout>
          </v-flex>
          <!--End Of Upstream Contribution-->
          <v-flex v-if="$vuetify.breakpoint.smAndDown" xs12 md6 lg6>
            <!-- Show title & subheading for phones -->
            <div v-if="$vuetify.breakpoint.smAndDown">
              <div
                v-if="currentProfile"
                class="headline heading font-weight-bold supplierTitle"
              >
                {{ currentProfile.listTitle }}
              </div>
              <div
                class="subheading font-weight-thin supplierSubTitle mb-5"
                style="color: rgb(167 164 164)"
              >
                <!-- {{ generatedSubHeading() }} -->
                {{ currentProfile.name }} donating
                {{ currentProfile.contributionDetails }} to charity
              </div>
              <div
                class="subheading font-weight-thin supplierSubTitle mb-5"
                style="color: rgb(167 164 164)"
              >
                <span
                  v-for="(cat, catIndex) in businessCategories"
                  :key="catIndex"
                  class="primary--text"
                  @click="onBizCategoryClick(catIndex)"
                >
                  {{ cat }}
                  <span
                    v-if="catIndex < businessCategories.length - 1"
                    class="text-darkBlue"
                  >
                    |
                  </span>
                </span>
              </div>
            </div>
            <v-layout column align-center justify-center>
              <!-- OLD CALL RAIL CODE -->
              <!-- <template
                      v-if="
                        !currentProfile.buttonText ||
                          currentProfile.buttonText == ''
                      "
                    >-->

              <!-- Image -->
              <v-flex xs12 style="width: 100%" class="pa-2 mb-3">
                <v-img :src="currentProfile.imageUrl" width="100%" class="mb-2">
                  <template v-slot:placeholder>
                    <v-img
                      src="https://upstreamnz.s3.ap-southeast-2.amazonaws.com/impactBuyerBadges/Approved+Supplier+Badge-01.svg"
                      width="166"
                      height="166"
                      class="mx-auto"
                    ></v-img>
                  </template>
                </v-img>
                <div class="profilePictureTitle">
                  {{ currentProfile.profilePictureTitle }}
                </div>
              </v-flex>

              <v-layout align-center style="width: 100%">
                <div class="headline heading" style="text-align: center">
                  <!-- Buttons  MOBILE-->
                  <v-layout row wrap>
                    <!-- Call Us button mobile-->
                    <v-flex
                      xs12
                      md6
                      v-if="
                        currentProfile.callRailPhone &&
                        currentProfile.callRailPhone != ''
                      "
                    >
                      <div class="pa-2">
                        <v-btn
                          color="#4dc8ed"
                          class="supplierBtn ma-0 capitalize"
                          :href="`tel:${currentProfile.callRailPhone}`"
                        >
                          <p class="mb-0">Call now</p>
                          <!-- <div class="headline">
                            <span style="color: #000">{{
                            currentProfile.callRailPhone
                          }}</span>
                          </div> -->
                        </v-btn>
                      </div>
                    </v-flex>
                    <!-- Email Button -->
                    <v-flex
                      :class="{
                        xs6: currentProfile.callRailPhone,
                        xs12:
                          !currentProfile.callRailPhone ||
                          $vuetify.breakpoint.smAndDown,
                      }"
                    >
                      <div class="pa-2">
                        <!--Email now mobile Button-->
                        <template v-if="currentProfile.emailButtonVisible">
                          <v-btn
                            large
                            dark
                            style="width: 100%"
                            color="#4dc8ed"
                            @click="
                              emailFormDialog = true;
                              fillFormData('emailEnquiry');
                            "
                            class="supplierBtn ma-0"
                          >
                            <v-icon left>mdi-email-outline</v-icon>
                            {{
                              $defaultText(
                                "Email now",
                                currentProfile,
                                "buttonText"
                              )
                            }}
                          </v-btn>
                          <template
                            v-if="
                              currentProfile.buttonSubText &&
                              currentProfile.buttonSubText !== ''
                            "
                          >
                            <br />
                            <div
                              class="caption"
                              style="color: #58595b !important"
                            >
                              {{ currentProfile.buttonSubText }}
                            </div>
                          </template>
                        </template>
                      </div>
                    </v-flex>
                    <!--Phone number mobile -->
                    <v-flex
                      v-if="
                        currentProfile.callRailPhone &&
                        currentProfile.callRailPhone != ''
                      "
                      xs12
                    >
                      <div class="pa-2">
                        <template>
                          <!-- <v-btn
                            color="transparent"
                            flat
                            class="phoneNoBtn"
                            @click="
                              copyToClipboard(currentProfile.callRailPhone)
                            "
                          > -->
                          <!--PHONE NUMBER MOBILE BUTTON-->
                          <div class="pa-2">
                            <v-layout
                              justify-center
                              row
                              fill-height
                              align-center
                            >
                              <v-icon color="#162c47" left>mdi-phone</v-icon>

                              <h2
                                style="
                                  font-size: 17px !important;
                                  display: inline-block;
                                "
                                class="telNum ma-0 primary--text"
                              >
                                <a
                                  :href="`tel:${currentProfile.callRailPhone}`"
                                >
                                  {{ currentProfile.callRailPhone }}</a
                                >
                              </h2>
                            </v-layout>
                          </div>

                          <!-- </v-btn> -->
                        </template>
                      </div>
                    </v-flex>
                    <!-- Affiliate Button -->
                    <v-flex xs12 md6>
                      <div class="pa-2">
                        <template
                          v-if="
                            currentProfile.affiliateButtonLink &&
                            currentProfile.affiliateButtonLink !== '' &&
                            currentProfile.affiliateButtonVisible !== '0'
                          "
                        >
                          <v-btn
                            large
                            color="#162C47"
                            style="color: white"
                            @click="
                              contactFormDialog = true;
                              fillFormData('contactEnquiry');
                            "
                            class="supplierBtn ma-0 capitalize general-color"
                          >
                            <p class="mb-0">
                              {{ currentProfile.affiliateButtonText }}
                            </p>
                          </v-btn>
                        </template>
                      </div>
                    </v-flex>

                    <v-flex
                      :class="{
                        xs6:
                          currentProfile.affiliateButtonLink &&
                          currentProfile.affiliateButtonLink !== '',
                        xs12:
                          !currentProfile.affiliateButtonLink ||
                          currentProfile.affiliateButtonLink === '' ||
                          $vuetify.breakpoint.smAndDown,
                      }"
                    >
                      <!-- Testimonial Button -->
<!--                      <div class="pa-2">-->
<!--                        <template>-->
<!--                          <v-btn-->
<!--                            large-->
<!--                            dark-->
<!--                            color="#162C47"-->
<!--                            @click="-->
<!--                              testimonialFormDialog = true;-->
<!--                              fillFormData('testimonial');-->
<!--                            "-->
<!--                            class="supplierBtn ma-0"-->
<!--                          >-->
<!--                            <v-icon left>mdi-star</v-icon>-->
<!--                            Leave a testimonial-->
<!--                          </v-btn>-->
<!--                        </template>-->
<!--                      </div>-->
                    </v-flex>
                  </v-layout>
                  <!---END OF BUTTONS MOBILE-------->

                  <br />

                  <!-- Phone number -->
                  <!-- <div
                    class="text-xs-left px-2 my-5"
                    v-if="currentProfile.callRailPhone"
                  >
                    <v-layout row>
                      <v-icon color="#162c47" left>mdi-phone</v-icon>
                      <h2 class="telNum ma-0">
                        {{ currentProfile.callRailPhone }}
                      </h2>
                    </v-layout>
                  </div> -->

                  <!-- Affiliate Subtext -->
                  <div
                    v-if="currentProfile.affiliateButtonSubText"
                    class="caption subText pa-2 mt-0"
                  >
                    {{ currentProfile.affiliateButtonSubText }}
                  </div>
                </div>
              </v-layout>
            </v-layout>
          </v-flex>

          <!-- Left: Locations & Services -->
          <v-flex xs12 md6 lg6 order-xs2 order-sm1>
            <!-- Show title & subheading for big screens -->
            <div v-if="$vuetify.breakpoint.mdAndUp">
              <div
                class="headline heading font-weight-bold supplierTitle mb-3"
                v-if="currentProfile"
              >
                {{ currentProfile.listTitle }}
              </div>
              <div
                class="subheading font-weight-thin supplierSubTitle"
                style="color: rgb(167 164 164)"
              >
                <!-- {{ generatedSubHeading() }} -->
                {{ currentProfile.name }} donating
                {{ currentProfile.contributionDetails }} to charity
              </div>

              <div
                class="subheading font-weight-thin supplierSubTitle mb-5"
                style="color: rgb(167 164 164)"
              >
                <span
                  v-for="(cat, catIndex) in businessCategories"
                  :key="catIndex"
                  class="primary--text"
                  @click="onBizCategoryClick(catIndex)"
                >
                  {{ cat
                  }}<span
                    v-if="catIndex < businessCategories.length - 1"
                    class="text-darkBlue"
                  >
                    |
                  </span>
                </span>
              </div>
            </div>

            <!----DESKTOP VIEW FOR PROFILE INFO--->
            <!--What we do section--->
            <v-layout row v-if="$vuetify.breakpoint.mdAndUp">
              <v-flex xs12>
                <h3 class="headline heading supplierHeading">What we do</h3>
                <hr class="heading headingUnderline" />
                <br />
                <div class="general-color" style="max-width: 600px">
                  {{ currentProfile.aboutWhatWeDo }}
                </div>
              </v-flex>
            </v-layout>
            <!--End of what we do section-->
            <div v-if="$vuetify.breakpoint.mdAndUp" class="servicesTable mb-5">
              <v-layout row>
                <!-- Servicing -->
                <v-flex xs12>
                  <h3 class="headline heading supplierHeading">Servicing</h3>
                  <hr class="heading headingUnderline" />
                  <br />
                  <div class="general-color">
                    {{ (currentProfile.serviceRegions ? currentProfile.serviceRegions : '').split(",").join(", ") }}
                  </div>
                  <div class="general-color">
                    {{ (currentProfile.serviceDistricts ? currentProfile.serviceDistricts : '').split(",").join(", ") }}
                  </div>
                </v-flex>

                <!-- Locations  -->
                <!-- <v-flex xs12 sm5>
                  <h3
                    class="headline heading supplierHeading"
                    v-if="currentProfile.locations != ''"
                  >
                    Locations
                  </h3>
                  <hr class="heading headingUnderline" />
                  <br />
                  <div
                    class="general-color"
                    v-if="currentProfile.locations != ''"
                  >
                    {{ currentProfile.locations }}
                  </div>
                </v-flex> -->
              </v-layout>

              <!-- Services -->
              <v-layout row wrap class="">
                <!-- Heading -->
                <v-flex xs12>
                  <h3
                    class="headline heading supplierHeading"
                    style="margin-top: 20px; width: 100%"
                  >
                    <template
                      v-if="
                        currentProfile.servicesHeadingOverride &&
                        currentProfile.servicesHeadingOverride !== ''
                      "
                      >{{ currentProfile.servicesHeadingOverride }}</template
                    >
                    <template v-else>
                      Services
                      <hr class="heading headingUnderline mt-2" />
                    </template>
                  </h3>
                </v-flex>

                <!-- Content -->
                <v-flex
                  v-for="(service, index) in currentProfile.services"
                  :key="`service_${index}`"
                  class="pa-0"
                  xs12
                  sm6
                >
                  <li class="servicesList general-color mb-1">{{ service }}</li>
                </v-flex>
              </v-layout>
            </div>
            <!--END OF DESKTOP VIEW FOR PROFILE INFO--------->
          </v-flex>

          <!-- Right: Image & buttons -->
          <v-flex
            v-if="$vuetify.breakpoint.mdAndUp"
            xs12
            md6
            lg6
            order-xs1
            order-sm2
          >
            <!-- Show title & subheading for phones -->
            <div v-if="$vuetify.breakpoint.smAndDown">
              <div class="headline heading font-weight-bold supplierTitle">
                {{ currentProfile.listTitle }}
              </div>
              <div
                class="subheading font-weight-thin supplierSubTitle mb-5"
                style="color: rgb(167 164 164)"
              >
                <!-- {{ generatedSubHeading() }} -->
                {{ currentProfile.name }} donating
                {{ currentProfile.contributionDetails }} to charity
              </div>
              <div
                class="subheading font-weight-thin supplierSubTitle mb-5"
                style="color: rgb(167 164 164)"
              >
                <span
                  v-for="(cat, catIndex) in businessCategories"
                  :key="catIndex"
                  class="primary--text"
                  @click="onBizCategoryClick(catIndex)"
                >
                  {{ cat }}
                  <span
                    v-if="catIndex < businessCategories.length - 1"
                    class="text-darkBlue"
                  >
                    |
                  </span>
                </span>
              </div>
            </div>
            <v-layout column align-center justify-center>
              <!-- OLD CALL RAIL CODE -->
              <!-- <template
                      v-if="
                        !currentProfile.buttonText ||
                          currentProfile.buttonText == ''
                      "
                    >-->

              <!-- Image -->
              <v-flex xs12 style="width: 67%" class="pa-2 mb-3">
                <v-img :src="currentProfile.imageUrl" width="100%" class="mb-2">
                  <template v-slot:placeholder>
                    <v-img
                      src="https://upstreamnz.s3.ap-southeast-2.amazonaws.com/impactBuyerBadges/Approved+Supplier+Badge-01.svg"
                      width="200"
                      height="200"
                      class="mx-auto"
                    ></v-img>
                  </template>
                </v-img>
                <div class="profilePictureTitle">
                  {{ currentProfile.profilePictureTitle }}
                </div>
              </v-flex>

              <!-- Buttons DESKTOP -->
              <v-layout align-center style="width: 67%">
                <v-flex xs12>
                  <div class="headline heading" style="text-align: center">
                    <v-layout row wrap>
                      <!-- Email Button -->
                      <v-flex
                        xs12
                        :class="{
                          xs12: $vuetify.breakpoint.smAndDown,
                        }"
                      >
                        <div class="pa-2">
                          <template v-if="currentProfile.emailButtonVisible">
                            <!--Email Now Desktop button-->
                            <v-btn
                              large
                              dark
                              style="width: 100%"
                              color="#4dc8ed"
                              @click="
                                emailFormDialog = true;
                                fillFormData('emailEnquiry');
                              "
                              class="supplierBtn ma-0"
                            >
                              <v-icon left>mdi-email-outline</v-icon>
                              {{
                                $defaultText(
                                  "Email now",
                                  currentProfile,
                                  "buttonText"
                                )
                              }}
                            </v-btn>
                            <template
                              v-if="
                                currentProfile.buttonSubText &&
                                currentProfile.buttonSubText !== ''
                              "
                            >
                              <br />
                              <div
                                class="caption"
                                style="color: #58595b !important"
                              >
                                {{ currentProfile.buttonSubText }}
                              </div>
                            </template>
                          </template>
                        </div>
                      </v-flex>

                      <v-flex
                        :class="{
                          xs12: $vuetify.breakpoint.smAndDown,
                        }"
                        xs12
                      >
                        <!-- Testimonial Button -->
<!--                        <div class="pa-2">-->
<!--                          <template>-->
<!--                            <v-btn-->
<!--                              large-->
<!--                              dark-->
<!--                              color="#162C47"-->
<!--                              @click="-->
<!--                                testimonialFormDialog = true;-->
<!--                                fillFormData('testimonial');-->
<!--                              "-->
<!--                              style="font-size: 17px"-->
<!--                              class="supplierBtn ma-0"-->
<!--                            >-->
<!--                              Leave a testimonial-->
<!--                            </v-btn>-->
<!--                          </template>-->
<!--                        </div>-->
                      </v-flex>
                      <!-- Call Us Button -->
                      <!-- Call us button desktop-->
                      <v-flex
                        xs12
                        v-if="
                          currentProfile.callRailPhone &&
                          currentProfile.callRailPhone != ''
                        "
                      >
                        <div class="pa-2">
                          <v-layout justify-center row fill-height align-center>
                            <v-icon color="#162c47" left>mdi-phone</v-icon>

                            <h2
                              style="
                                font-size: 17px !important;
                                display: inline-block;
                              "
                              class="telNum ma-0 primary--text"
                            >
                              <a :href="`tel:${currentProfile.callRailPhone}`">
                                {{ currentProfile.callRailPhone }}</a
                              >
                            </h2>
                          </v-layout>
                        </div>
                      </v-flex>

                      <!-- Affiliate Button -->
                      <v-flex
                        v-if="
                          currentProfile.affiliateButtonLink &&
                          currentProfile.affiliateButtonLink !== '' &&
                          (currentProfile.affiliateButtonVisible !== '0' && currentProfile.affiliateButtonVisible !== 0)
                        "
                        xs12
                      >
                        <div class="pa-2">
                          <template
                            v-if="
                              currentProfile.affiliateButtonLink &&
                              currentProfile.affiliateButtonLink !== '' &&
                              (currentProfile.affiliateButtonVisible !== '0' && currentProfile.affiliateButtonVisible !== 0)
                            "
                          >
                            <v-btn
                              large
                              color="#162C47"
                              style="color: white"
                              @click="
                                contactFormDialog = true;
                                fillFormData('contactEnquiry');
                              "
                              class="supplierBtn ma-0 capitalize general-color"
                            >
                              <p class="mb-0">
                                {{ currentProfile.affiliateButtonText }}
                              </p>
                            </v-btn>
                          </template>
                        </div>
                      </v-flex>
                    </v-layout>
                    <br />
                    <!-- Affiliate Subtext -->
                    <div
                      v-if="currentProfile.affiliateButtonSubText && (currentProfile.affiliateButtonVisible !== '0' && currentProfile.affiliateButtonVisible !== 0)"
                      class="caption subText pa-2 mt-0"
                    >
                      {{ currentProfile.affiliateButtonSubText }}
                    </div>
                  </div>
                </v-flex>
              </v-layout>
              <!--BUTTONS DESKTOP END------>
            </v-layout>
          </v-flex>

          <v-flex xs12>
            <div
              v-if="$vuetify.breakpoint.smAndDown"
              class="servicesTable my-5"
            >
              <v-layout row>
                <v-flex xs12>
                  <h3 class="headline heading supplierHeading">What we do</h3>
                  <hr class="heading headingUnderline" />
                  <br />
                  <div class="general-color" style="max-width: 600px">
                    {{ currentProfile.aboutWhatWeDo }}
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row>
                <!-- Servicing -->
                <v-flex xs12>
                  <h3 class="headline heading supplierHeading">Servicing</h3>
                  <hr class="heading headingUnderline" />
                  <br />
                  <div class="general-color">
                    {{ (currentProfile.serviceRegions ? currentProfile.serviceRegions : '').split(",").join(", ") }}
                  </div>
                  <div class="general-color">
                    {{ (currentProfile.serviceDistricts ? currentProfile.serviceDistricts : '').split(",").join(", ") }}
                  </div>
                </v-flex>
              </v-layout>

              <!-- Services -->
              <v-layout row wrap class="">
                <!-- Heading -->
                <v-flex xs12>
                  <h3
                    class="headline heading supplierHeading"
                    style="margin-top: 20px; width: 100%"
                  >
                    <template
                      v-if="
                        currentProfile.servicesHeadingOverride &&
                        currentProfile.servicesHeadingOverride !== ''
                      "
                      >{{ currentProfile.servicesHeadingOverride }}</template
                    >
                    <template v-else>
                      Services
                      <hr class="heading headingUnderline mt-2" />
                    </template>
                  </h3>
                </v-flex>

                <!-- Content -->
                <v-flex
                  v-for="(service, index) in currentProfile.services"
                  :key="`service_${index}`"
                  class="pa-0"
                  xs12
                  sm6
                >
                  <li class="servicesList general-color mb-1">
                    {{ service }}
                  </li>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex v-if="currentProfile.promotionLive" xs12>
        <a :href="currentProfile.destinationUrl" target="_tab">
          <v-img
            v-if="!$vuetify.breakpoint.xs"
            style="cursor: pointer; border-radius: 5px"
            :src="currentProfile.desktopUrl"
          />
          <v-img
            v-else
            style="cursor: pointer; border-radius: 5px"
            :src="currentProfile.mobileUrl"
          />
        </a>
      </v-flex>

      <!-- <v-layout row wrap class="wwSection">
            <v-flex xs12 md6 class="whoWeAre">
              <div
                class="container"
                :class="{ mobileContainer: $vuetify.breakpoint.smAndDown }"
              >
                <div class="heading">Who we are</div>
                <div class="body-1">{{ currentProfile.aboutUs }}</div>
              </div>
            </v-flex>
            <v-flex xs12 md6 class="whatWeDo">
              <div
                class="container"
                :class="{ mobileContainer: $vuetify.breakpoint.smAndDown }"
              >
                <div class="heading">What we do</div>
                <div class="body-1">{{ currentProfile.whatWeDo }}</div>
              </div>
            </v-flex>
          </v-layout> -->

      <v-layout row wrap class="mt-5">
        <!-- Who we are & What we do -->
        <v-flex
          xs12
          md6
          class="wwSection pa-5"
          :style="
            $vuetify.breakpoint.smAndDown
              ? 'min-height: 300px;'
              : 'min-height: 650px;'
          "
        >
          <div style="margin: auto; max-width: 790px">
            <h1 class="headline heading mb-4">Who we are</h1>
            <div style="line-height: 1.5 !important">
              {{ currentProfile.whoAreWe }}
            </div>
          </div>
          <div v-if="supplierSustainabilityList.length > 0">
            <sustainability-slider
              :supplierSustainabilityList="supplierSustainabilityList"
            ></sustainability-slider>
          </div>
        </v-flex>

        <!-- Testimonials -->
        <v-flex
          xs12
          md6
          :class="
            $vuetify.breakpoint.mdAndUp
              ? 'ftSection ftSectionHeightDesktop ftSectionBackgroundDesktop pa-5'
              : 'ftSection ftSectionHeightMobile pa-5'
          "
        >
          <div v-if="featuredTestimonials.length > 0" class="contentMaxWidth">
            <h4 class="heading supplierTitle mb-4">
              <template>Testimonials</template>
            </h4>
            <v-carousel
              hide-controls
              hide-delimiters
              touchless
              light
              class="elevation-0 testimonialCarousel"
              interval="10000"
              v-if="featuredTestimonials.length > 0"
            >
              <v-carousel-item
                v-for="(testimonial, index) in featuredTestimonials"
                :key="index"
                style="text-align: left; height: auto"
              >
                <p style="font-size: 20px !important; font-weight: 300">
                  "{{ testimonial.message }}"
                </p>
                <p class="testimonialName">{{ testimonial.fullName }}</p>
              </v-carousel-item>
            </v-carousel>
            <v-btn
              v-if="testimonials.length > 0 && $vuetify.breakpoint.mdAndUp"
              @click="onSeeFullListClick"
              color="#162c47"
              class="testimonialBtn ma-0 mt-5"
            >
              {{ seeAllTestimonials ? "Hide list" : "See the full list" }}
            </v-btn>
          </div>
          <div v-else class="contentMaxWidth">
            <h2 class="mb-5" style="color: #162c47">
              As an approved supplier we are proud to partner with Upstream to
              positively impact the lives of New Zealand’s young people.
            </h2>
          </div>
        </v-flex>
      </v-layout>

      <!--FULL LIST OF TESTIMONIAL-->
      <transition name="fade">
        <v-flex
          ref="testimonials"
          class="mb-5"
          v-show="seeAllTestimonials"
          xs12
        >
          <v-layout id="allTestimonials" row wrap>
            <v-flex
              class="pa-4"
              xs12
              sm6
              md6
              xl4
              v-for="(testimonial, index) in testimonials"
              :key="index"
            >
              <v-card class="pa-3" flat>
                <div style="height: 200px">
                  <p
                    style="
                      height: 150px;
                      font-size: 20px !important;
                      font-weight: 300;
                      color: #162c47;
                      text-overflow: ellipsis;
                    "
                  >
                    "{{ testimonial.message }}"
                  </p>
                  <p class="testimonialName">{{ testimonial.fullName }}</p>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </transition>

      <!-- Learn More -->
      <v-flex v-if="currentProfile.learnMore.length > 0" xs12>
        <div class="headline sectionHeader">
          <h1 class="heading pa-5">Learn More</h1>
        </div>
        <v-layout class="px-4" row wrap>
          <v-flex
            xs12
            sm6
            v-for="(learnMore, index) in currentProfile.learnMore"
            :key="`learnMore_${index}`"
            class="pa-2"
          >
            <v-card height="200">
              <v-card-title>
                <h3>{{ learnMore.title }}</h3>
              </v-card-title>
              <v-card-text>
                <a
                  @click="addClick(learnMore.id)"
                  target="_blank"
                  :href="learnMore.fileLink"
                  >Click here to view PDF info sheet</a
                >
              </v-card-text>
              <v-img
                style="
                  position: absolute;
                  bottom: 5px;
                  right: 5px;
                  height: 60px;
                  width: 60px;
                  cursor: default;
                "
                src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/noun_Info_2510064.png?alt=media&token=2b04c752-59a3-402c-a176-c0c3a35f82a3"
              />
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- Our Work -->
      <v-flex xs12 v-if="currentProfile.ourWork.length > 0">
        <div class="ourWorkSection my-5 mx-auto">
          <div class="sectionHeader">
            <template
              v-if="
                currentProfile.ourWorkHeadingOverride &&
                currentProfile.ourWorkHeadingOverride !== ''
              "
              ><h1 class="heading">
                {{ currentProfile.ourWorkHeadingOverride }}
              </h1></template
            >
            <template v-else>
              <h1 class="heading pa-5">Our work</h1>
            </template>
          </div>
          <v-layout row wrap>
            <v-flex
              xs12
              sm6
              md4
              v-for="(work, index) in currentProfile.ourWork"
              :key="`workImage_${index}`"
            >
              <v-card flat tile class="d-flex pa-5 ourWorkCard">
                <silentbox-single
                  v-if="work.imageUrl"
                  :src="work.imageUrl"
                  :description="work.description"
                >
                  <v-img :src="work.imageUrl" position="center center" />
                  <p class="pt-5">
                    {{ work.description }}
                  </p>
                </silentbox-single>
                <silentbox-single
                  v-else
                  :src="work.videoUrl"
                  :description="work.description"
                >
                  <v-img
                    :src="`https://img.youtube.com/vi/${work.videoID}/hqdefault.jpg`"
                    aspect-ratio="1.75"
                    position="center center"
                  />
                  <p>
                    {{ work.description }}
                  </p>
                </silentbox-single>
              </v-card>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>

      <!-- Duplicate? -->
      <!-- <v-flex v-if="testimonials.length > 0" xs12>
        <div class="headline sectionHeader">
          <template>Testimonials</template>
        </div>
        <v-layout row wrap>
          <v-flex
            xs12
            sm6
            md4
            v-for="(testimonial, index) in testimonials"
            :key="index"
          >
            <v-card flat tile style="background: white" class="d-flex">
              <v-card-text>
                <p style="font-size: 20px !important; font-weight: 300">
                  "{{ testimonial.message }}"
                </p>
                <p style="font-weight: bold">{{ testimonial.fullName }}</p>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex> -->
    </v-layout>

    <v-dialog v-model="emailFormDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Email Enquiry</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form ref="salesEnquiryForm">
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="formData.fullName"
                    :rules="[(v) => !!v || 'Name is required']"
                    label="Full Name"
                  />
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="formData.mobile"
                    :rules="[(v) => !!v || 'Phone number is required']"
                    label="Mobile / Phone Number"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="formData.email"
                    :rules="[
                      (v) => !!v || 'Email is required',
                      (v) =>
                        !v ||
                        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                        'E-mail must be valid',
                    ]"
                    label="Email"
                  />
                </v-flex>
                <v-flex xs12>
                  {{
                    $defaultText(
                      "Attach a file",
                      currentProfile,
                      "emailFileDescription"
                    )
                  }}
                  <br />
                  <input type="file" @change="fileChange" />
                  <div v-if="fileUploadError" class="text-danger">
                    {{ fileUploadError }}
                  </div>
                </v-flex>
                <v-flex xs12 v-if="files.length > 0">
                  <p class="mb-0" v-for="(file, i) in files" :key="i">
                    {{ file.name }}
                  </p>
                  <p class="mt-2">
                    {{ files.length }} attachment{{
                      `${files.length > 1 ? "s" : ""}`
                    }}
                  </p>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="formData.message"
                    :label="`Your message to ${currentProfile.name}`"
                    required
                  />
                </v-flex>

                <!-- Reference Area -->
                <v-flex xs12>
                  <v-select
                    v-model="formData.reference"
                    :items="selectItems"
                    label="How did you hear about us?"
                  />
                  <!-- Other Option -->
                  <v-textarea
                    v-if="formData.reference === 'Other'"
                    v-model="formData.referenceOther"
                    label="Other..."
                  ></v-textarea>
                </v-flex>
                <v-flex xs12>
                  Do you give Upstream permission to email you seasonally about
                  the impact your purchases are having?*
                  <v-select
                    v-model="formData.permission"
                    :items="['Yes', 'No']"
                    :rules="[(v) => !!v || 'Permission selection is required']"
                  />
                </v-flex>
                <v-flex>
                  <v-checkbox
                    :rules="[
                      (v) =>
                        v ||
                        'You need to agree to the privacy policy to progress',
                    ]"
                    v-model="checkbox"
                    :label="`By sending this email, I agree to the Upstream 
                  privacy policy. I understand that Upstream is a copied recipient of this email, 
                  in order to provide evidence that generates impact for our charities.`"
                  ></v-checkbox>
                </v-flex>
                <v-flex>
                  <a
                    href="https://upstreamnz.s3.ap-southeast-2.amazonaws.com/TandCs/Upstream+combined+T%26C_Privacy+Policy.pdf"
                    target="_blank"
                    >Privacy Policy</a
                  >
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            v-if="!isSubmitting"
            color="blue darken-1"
            flat
            @click="
              emailFormDialog = false;
              formData = {};
            "
            >Close</v-btn
          >
          <v-btn
            :loading="isSubmitting"
            :disabled="isSubmitting"
            color="blue darken-1"
            flat
            @click="sendEmail()"
          >
            Send
          </v-btn>
          <div v-if="sendError" class="text-danger">
            {{ sendError }}
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="testimonialFormDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Leave a Testimonial</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form ref="testimonialForm">
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="formData.fullName"
                    :rules="[(v) => !!v || 'Name is required']"
                    label="Full Name"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="formData.email"
                    :rules="[(v) => !!v || 'Email is required']"
                    label="Email"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    :rules="[(v) => v.length > 3 || 'Please enter a message']"
                    v-model="formData.message"
                    :label="`Your Testimonial for ${currentProfile.name}`"
                    counter="225"
                    maxlength="225"
                    required
                  />
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            flat
            @click="
              testimonialFormDialog = false;
              formData = {};
            "
            >Close</v-btn
          >
          <v-btn
            color="blue darken-1"
            flat
            :loading="saving"
            @click="saveTestimonial()"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="contactFormDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{
              $defaultText(
                "Help our charities have the evidence of your enquiry, before you're transfered to their website",
                currentProfile,
                "contactUsHeader"
              )
            }}
          </span>
        </v-card-title>
        <v-card-text>
          <span>
            {{
              $defaultText(
                `Your basic info will provide evidence to show our supplier, who gives funding for our Good Causes at no cost to the customer. ( YOUR EMAIL WON'T BE USED FOR MARKETING )`,
                currentProfile,
                "contactUsSubheading"
              )
            }}
          </span>
          <v-container grid-list-md>
            <v-form ref="contactForm">
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="contactData.fullName"
                    :rules="[(v) => !!v || 'Full Name is required']"
                    label="Full Name"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="contactData.email"
                    :rules="[(v) => !!v || 'Email is required']"
                    label="Email"
                  />
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            flat
            @click="
              contactFormDialog = false;
              contactData = {};
            "
            >Close</v-btn
          >
          <v-btn color="blue darken-1" flat @click="sendContactForm()"
            >Send</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="emailFormConfirmation" max-width="350px">
      <v-card>
        <div class="enquiry-form-success" v-if="emailFormConfirmation">
          &nbsp;
        </div>
        <v-card-text>
          Thank you for contacting <b>{{ currentProfile.name }}</b> creating an
          opportunity to make a charitable impact for the young people we support through
          our partner charities.
          <b>{{ currentProfile.name }}</b> will be in touch with you soon. If
          you require any further assistance please do not hesitate to get in
          touch – we are here to help you!
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            flat
            @click="emailFormConfirmation = false"
            >Close</v-btn
          >
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="testimonialConfirmation" max-width="350px">
      <v-card>
        <v-card-text>
          Thank you for submitting your testimonial, Upstream and the Supplier
          will be notified of the testimonial. We appreciate the time taken to
          leave the testimonial.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            flat
            @click="testimonialConfirmation = false"
            >Close</v-btn
          >
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      color="green"
      class="text--white"
      :timeout="3000"
      top
      right
    >
      Copied To Clipboard
      <v-btn icon flat @click="snackbar = false">
        <v-icon> mdi-close </v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import sustainabilitySlider from "@/components/businessComponents/sustainabilitySlider.vue";
import apiV2 from '@/apiV2'

export default {
  components: {
    sustainabilitySlider,
  },
  data: () => ({
    isLoading: true,
    //sustainability prop to be passed to the
    //sustainabilitySlider component
    supplierSustainabilityList: [],
    currentSustainabilityFieldList: [
      "sustainabilityCarbon",
      "sustainabilityEnergy",
      "sustainabilitySME",
      "sustainabilitySocialEnterprise",
      "sustainabilitySocialImpact",
      "sustainabilityWaste",
      "sustainabilityWater",
    ],

    //testimonials
    seeAllTestimonials: false,

    checkbox: false,
    formData: {
      message: "",
      reference: "",
      referenceOther: "",
    },
    newApiFormData: new FormData(),
    fileUploadError: null,
    sendError: null,
    saving: false,
    isSubmitting: false,
    contactData: {},
    fileData: {},
    includeFileData: false,
    files: [],
    emailFormDialog: false,
    contactFormDialog: false,
    emailFormConfirmation: false,
    testimonialFormDialog: false,
    testimonialConfirmation: false,
    customRoutes: {
      coffee: "inrvq2lcoW1PV30PsdVH",
      power: "z14vz7TiRWXNLRnKBbFD",
    },
    selectItems: [
      "Another Supplier",
      "Charity Promoted",
      "Facebook",
      "Friend/Family",
      "Google Adwords",
      "Promotion Material",
      "Web Search",
      "YouTube Video",
      "Other",
    ],
    //snackbar to show
    //copyToClipboard is executed
    snackbar: false,

    //breadcrumb
    breadcrumbItems: [
      // {
      //   text: "Nationwide",
      //   disabled: false,
      //   href: "/",
      // },
      // {
      //   text: "Category",
      //   disabled: false,
      //   href: "",
      // },
    ],
  }),

  computed: {
    //Programmatic Scrolling
    target() {
      return "#allTestimonials";
    },

    options() {
      return {
        duration: 900,
        offset: -1,
        easing: "easeInOutCubic",
      };
    },

    ...mapGetters({
      user: "user",
      userData: "user/userData",
      currentProfile: "business/currentProfile",
      goodCauses: "goodCauses/listOrderedByCategories",
      keywords: "business/keywords",
      categoriesByName: "categories/byName",
      subCategoriesByName: "categories/subCatByName",
      categories: "categories/list",
    }),
    testimonials: function () {
      if (this.currentProfile.testimonial) {
        let array = this.currentProfile.testimonial.filter(
          (x) => x.visible == 1 || x.visible == "1"
        );
        return array;
      } else {
        return {};
      }
    },
    featuredTestimonials: function () {
      if (this.currentProfile.testimonial) {
        let array = this.currentProfile.testimonial.filter(
          (x) => x.featured == 1
        );
        return array;
      } else {
        return {};
      }
    },
    businessCategories() {
      let businessCategories = [];
      if (this.currentProfile.category) {
        let categories = this.currentProfile.category.split(",");
        categories.forEach((cat) => {
          if (typeof this.categoriesByName[cat] != "undefined") {
            businessCategories.push(this.categoriesByName[cat].name);
          }
        });
      }
      return businessCategories;
    },
  },
  created() {
    this.$nextTick(async function () {
      if (!this.$route.params.hasOwnProperty("id")) {
        this.$route.params.id = "inrvq2lcoW1PV30PsdVH";
      }
      if (this.$route.name === "buy") {
        this.$route.params.id = this.customRoutes[this.$route.params.id];
      }
      if (this.$route.name === "use") {
        this.$route.params.id = this.customRoutes[this.$route.params.id];
      }
      if (this.$route.params.hasOwnProperty("keyword")) {
        await this.$store.dispatch(
          "business/loadProfileByKeyword",
          this.$route.params.keyword
        );
      } else {
        this.isLoading = true;
        await this.$store.dispatch(
          "business/loadProfile",
          this.$route.params.id
        );
        // console.log(this.currentProfile);
        this.isLoading = false;
      }

      if (this.currentProfile.aboutWhatWeDo) {
        this.$store.commit(
          "vueMeta/setDescriptionContent",
          this.currentProfile.aboutWhatWeDo
        );
      }
      this.setMetaData();
      this.initialiseBreadCrumb();
      this.initialiseSustainabilityList();
    });
  },
  methods: {
    setMetaData() {
      let category = null;
      let region = null;
      let categoryDescription = "";
      let categoryList = this.currentProfile.category.includes(",")
        ? this.currentProfile.category.split(",")
        : [this.currentProfile.category];
      if (this.$route.params.hasOwnProperty("categoryId")) {
        category = this.categories.find(
          (e) => e.id == this.$route.params.categoryId
        );
      }

      if (this.$route.params.hasOwnProperty("servicing")) {
        region = this.$route.params.servicing;
      }
      if (categoryList.length > 1) {
        for (let i = 0; i < categoryList.length; i++) {
          let currentCat = this.categories.find(
            (e) => e.id == categoryList[i]
          ).name;

          if (i == 0) {
            categoryDescription = currentCat;
          } else if (i == categoryList.length - 1) {
            categoryDescription = categoryDescription + " and " + currentCat;
          } else {
            categoryDescription = categoryDescription + ", " + currentCat;
          }
        }
      } else {
        categoryDescription = this.categories.find(
          (e) => e.id == categoryList[0]
        ).name;
      }
      let title = category
        ? `${this.currentProfile.name} - ${category.name} - Upstream Charity Approved Supplier`
        : `${this.currentProfile.name} - Upstream Charity Approved Supplier`;
      let description = `Use ${
        this.currentProfile.name
      } for ${categoryDescription} in ${
        region == "Nationwide" ? "New Zealand" : region
      } and improve the well-being of children and youth by using an Upstream Charity Approved Supplier. ${
        this.currentProfile.name
      } are donating ${this.currentProfile.contributionDetails} to charity.`;

      this.$store.commit("vueMeta/setTitleTag", title);
      this.$store.commit("vueMeta/setDescriptionContent", description);
      this.$store.commit("vueMeta/setTitleContent", title);
    },
    onBizCategoryClick(index) {
      let categories = this.currentProfile.category.split(",");
      let servicing = this.$route.params.servicing;
      this.$router.push(`/searchResults/${servicing}/${categories[index]}`);
    },
    initialiseBreadCrumb() {
      this.breadcrumbItems = [];
      let routeParams = this.$route.params;
      let servicing = null;
      if (routeParams.hasOwnProperty("service")) {
        this.breadcrumbItems.push({
          text: routeParams.service,
          disabled: false,
          href: `/searchResults/service/${routeParams.service}/Nationwide`,
        });
        this.breadcrumbItems.push({
          text: "Nationwide",
          disabled: false,
          href: `/searchResults/Nationwide/0`,
        });
      } else {
        if (routeParams.hasOwnProperty("servicing")) {
          servicing = routeParams.servicing;
          this.breadcrumbItems.push({
            text: routeParams.servicing,
            disabled: false,
            href: `/searchResults/${servicing}/0`,
          });
        } else {
          this.breadcrumbcrumbItems.push({
            text: "Nationwide",
            disabled: false,
            href: "/searchResults/Nationwide/0",
          });
        }

        let categorySubHref = servicing
          ? `/searchResults/${servicing}`
          : "/searchResults/Nationwide";

        if (this.categories.length > 1) {
          if (routeParams.hasOwnProperty("categoryId")) {
            let category = this.categories.find(
              (e) => e.id == routeParams.categoryId
            );
            if (category) {
              this.breadcrumbItems.push({
                text: category.name,
                disabled: false,
                href: `${categorySubHref}/${category.id}`,
              });
            }
          } else {
            this.breadcrumbItems.push({
              text: "All Categories",
              disabled: false,
              href: `${categorySubHref}/0`,
            });
          }
        } else {
          this.breadcrumbItems.push({
            text: "All Categories",
            disabled: false,
            href: servicing ? `${categorySubHref}}/0` : `${categorySubHref}/0`,
          });
        }
      }
    },
    copyToClipboard(value) {
      this.snackbar = true;
      var TempText = document.createElement("input");
      TempText.value = value;
      document.body.appendChild(TempText);
      TempText.select();

      document.execCommand("copy");
      document.body.removeChild(TempText);
    },
    initialiseSustainabilityList() {
      //This is the list (prop) to be used for the
      //sustainabilityList component
      let sustainabilityList = [];
      if (this.currentProfile.sustainabilityNotes) {
        let notes = JSON.parse(this.currentProfile.sustainabilityNotes);

        this.currentSustainabilityFieldList.forEach((e) => {
          if (this.currentProfile[e] == "1" || this.currentProfile == 1) {
            let item = {
              field: e,
              notes: notes[e],
            };
            sustainabilityList.push(item);
          }
        });
        this.supplierSustainabilityList = sustainabilityList;
      }
    },
    onSeeFullListClick() {
      this.seeAllTestimonials = !this.seeAllTestimonials;
      setTimeout(() => {
        if (this.seeAllTestimonials) {
          this.$vuetify.goTo(this.target, this.options);
        }
      }, 100);
    },

    generatedSubHeading() {
      if (this.currentProfile.category) {
        let heading = "|";
        let category = this.currentProfile.category.split(",");

        let subCategory = this.currentProfile.subCategory.split(",");
        category.forEach((cat) => {
          if (typeof this.categoriesByName[cat] != "undefined") {
            heading = `${heading} ${this.categoriesByName[cat].name} |`;
          }
        });
        subCategory.forEach((subCat) => {
          if (typeof this.subCategoriesByName[subCat] != "undefined") {
            heading = `${heading} ${this.subCategoriesByName[subCat].name} |`;
          }
        });
        heading = `${heading}`;
        return heading;
      }
    },
    addClick(on) {
      let payload = {
        type: "learnMoreClick",
        id: this.currentProfile.id,
        on: on,
      };
      this.$store.dispatch("clicks/saveClick", payload);
    },
    saveTestimonial() {
      if (this.$refs.testimonialForm.validate()) {
        this.saving = true;
        this.formData.business_id = this.currentProfile.id;
        if (typeof this.currentProfile.testimonial !== "undefined") {
          this.formData.idx = this.currentProfile.testimonial.length;
        } else {
          this.formData.idx = 0;
        }
        this.$store
          .dispatch("business/createTestimonial", this.formData)
          .then((testimonial) => {
            this.testimonialConfirmation = true;
            this.formData.user_id = this.userData.firebase_id;
            this.saving = false;
            this.testimonialFormDialog = false;
          });
      }
    },
    fillFormData(type) {
      if (this.userData.fullName) {
        if (type === "emailEnquiry") {
          this.formData.fullName = this.userData.fullName;
        }
        if (type === "contactEnquiry") {
          this.contactData.fullName = this.userData.fullName;
          this.contactData.email = this.userData.email;
        }
        if (type === "testimonial") {
          this.formData.fullName = this.userData.fullName;
          this.formData.user_id = this.userData.firebase_id;
        }
        if (this.userData.updates == 1) {
          this.formData.permission = "Yes";
        }
        this.formData.email = this.userData.email;
        this.formData.mobile = this.userData.phone;
      }
      this.formData.goodCause_id = 16; //UpstreamNZ charity foundation
    },
    fileChange(ev) {
      const file = ev.target.files[0];

      if (!file) return;

      // Check file size first (10MB limit)
      if (file.size > 10000000) {
        this.fileUploadError = 'Sorry, that file is too big. (Max size 10MB)';
        return;
      } else {
        this.fileUploadError = '';
      }

      if (this.files.length >= 10) {
        this.fileUploadError = 'Sorry, you can only attach up to 10 files.';
        return;
      }

      this.fileUploadError = null;

      this.newApiFormData.append('Attachments', file, file.name);

      this.files.push({
        name: file.name,
        type: file.type,
        size: file.size
      });
    },
    async sendEmail() {
      if (this.$refs.salesEnquiryForm.validate()) {
        this.isSubmitting = true;
        this.formData.business_id = this.currentProfile.id;
        if (this.includeFileData === true) {
          this.formData.file = this.files;
        }
        try{
          this.newApiFormData.set('SupplierId', this.currentProfile.id);
          this.newApiFormData.set('IndividualCustomerName', this.formData.fullName);
          this.newApiFormData.set('IndividualCustomerPhoneNumber', this.formData.mobile);
          this.newApiFormData.set('IndividualCustomerEmail', this.formData.email);
          this.newApiFormData.set('Message', this.formData.message);
          this.newApiFormData.set('EmailPermission', this.formData.permission);
          this.newApiFormData.set('HeardFrom', this.formData.reference);
          this.newApiFormData.set('HeardFromOther', this.formData.referenceOther);

          let response = await apiV2.post('Leads/CreateLeadAnonymous', this.newApiFormData);

          if (response.status !== 200) {
            this.sendError = `Error when sending: error code ${response.status}: ${response.statusText}.`;
            this.isSubmitting = false;
            return;
          }
          this.sendError = null;
          this.emailFormDialog = false;
          this.emailFormConfirmation = true;
          this.$forceUpdate();
          this.isSubmitting = false;
          this.newApiFormData = new FormData();
          this.files = [];
        } catch (e) {
          console.log(e);
          this.sendError = `Error when sending, please try again later.`;
          this.isSubmitting = false;
        }
      }
    },
    sendContactForm() {
      if (this.$refs.contactForm.validate()) {
        let date = new Date();
        let timeStamp = `${date.getUTCFullYear()}-${date.getUTCMonth()}-${date.getUTCDate()} ${date.getUTCHours()}:${date.getUTCMinutes()}:${date.getUTCSeconds()}`;
        this.contactData.business_id = this.currentProfile.id;
        this.contactData.timeStamp = timeStamp;
        if (!this.currentProfile.affiliateButtonLink.includes("https://")) {
          // if URL does not contain https:// add it.
          this.currentProfile.affiliateButtonLink = `https://${this.currentProfile.affiliateButtonLink}`;
        }
        if (!this.currentProfile.affiliateButtonLink.includes("?")) {
          this.currentProfile.affiliateButtonLink =
            this.currentProfile.affiliateButtonLink + "?upstreamnz=1";
        }
        this.formData.goodCause_id = 16; //UpstreamNZ charity foundation
        this.currentProfile.affiliateButtonLink =
          this.currentProfile.affiliateButtonLink +
          "&fullName=" +
          this.contactData.fullName +
          "&email=" +
          this.contactData.email +
          "&goodCause=" +
          this.contactData.goodCause_id;
        this.$store.dispatch(
          "emailSending/sendAffiliateLinkNotice",
          this.contactData
        );
        this.$store
          .dispatch("affiliateLinkClicks/save", this.contactData)
          .then(() => {
            this.contactFormDialog = false;
          });
        this.currentProfile.affiliateButtonLink = encodeURI(
          this.currentProfile.affiliateButtonLink
        );
        window.open(
          this.currentProfile.affiliateButtonLink,
          "_blank",
          "location=yes"
        );
      }
    },
    contact() {
      this.currentProfile.affiliateButtonLink = encodeURI(
        this.currentProfile.affiliateButtonLink
      );
      if (this.currentProfile.useContactForm === true) {
        this.contactFormDialog = true;
      } else {
        window.open(
          this.currentProfile.affiliateButtonLink,
          "_blank",
          "location=yes"
        );
      }
    },
    goodCauseDropDownName(name) {
      name = name.replace("( Impact an Area )", "");
      name = name.replace("( Impacts Overall )", "");
      return name;
    },
  },
};
</script>

<style>
/* *****View All Testimonial Animation********* */
.fade-enter-active,
.face-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
/******End Of View All Testimonial Animation****** */
button {
  text-transform: none !important;
}

.text-darkBlue {
  color: #162c47;
}

.heading {
  color: #4dc8ed;
}

.application {
  background-color: white !important;
}

.sectionHeader {
  color: #4dc8ed;
}

.nl2br {
  white-space: pre-line;
}

.businessLogo {
  max-width: 100%;
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.servicesList {
  list-style-type: none;
}

.telNum {
  font-size: 17px !important;
  font-weight: bold !important;
}

.contributionIcon {
  font-size: 100px !important;
}

.contributionIconMobile {
  font-size: 40px !important;
}
.contributionSectionMobile {
}

.contributionSection {
  width: 100%;
  padding-top: 10%;
}

.contributionSection h3 {
  margin: 0;
  font-weight: bold !important;
  font-size: 2.5rem !important;
}

.contributionSection p {
  margin-bottom: 0;
  font-size: 30px !important;
}

.general-color {
  color: #162c47 !important;
}

.supplierPageContent {
  max-width: 1700px;
  margin: auto;
}

.supplierTitle {
  line-height: normal !important;
}

.supplierSubTitle {
  font-size: 20px !important;
}

.supplierHeading {
  display: inline-block;
  font-size: 25px !important;
  font-weight: bold !important;
}

.halfWidth {
  width: 50% !important;
}

.supplierBtn {
  font-size: 17px;
  font-weight: lighter !important;
  padding: 30px 0;
  width: 100%;
  color: white !important;
}

.phoneNoBtn {
  font-size: 17px;
  font-weight: lighter !important;
  padding: 30px 0;
  border: 1px solid transparent !important;
  box-shadow: none;
  width: 100%;
}

.disable-pointer-events {
  pointer-events: none;
}

.capitalize {
  text-transform: lowercase !important;
}

.capitalize p {
  font-size: 20px !important;
}

.capitalize p::first-letter {
  text-transform: uppercase !important;
}

.contentMaxWidth {
  max-width: 600px;
  margin: auto;
}

.wwSection {
  background-color: #162c47;
  color: white;
  /* padding: 5% 10%; */
}

.wwSection > div {
  font-size: 18px !important;
}

.ftSection {
  background-color: #4dc8ed;
  color: white !important;
  /* padding: 5% 10%; */

  background-position: bottom -90px right -280px;
  background-size: 1300px auto;
}

.ftSectionHeightDesktop {
  min-height: 650px;
}

.ftSectionHeightMobile {
  min-height: 300px;
}
.ftSectionBackgroundDesktop {
  background-image: url(https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/appImages%2Ftestimonials_pattern_full.svg?alt=media&token=99ed639b-6dfd-4ae4-a8f2-809eaf83c7b6);
}

.ftSection h4 {
  color: white;
}

.ourWorkSection {
  max-width: 1570px;
}

.ourWorkCard p {
  width: 100%;
  text-align: center;
  text-decoration: none !important;
  font-size: 24px !important;
}

.headingUnderline {
  border: 0;
  border-top: 2px solid;
  width: 70%;
}

.subText {
  font-size: 16px !important;
  text-align: left;
  color: #58595b !important;
}

.testimonialName {
  font-weight: bold;
  font-size: 25px !important;
  color: #162c47;
}

.testimonialBtn {
  color: white !important;
  padding: 30px 50px !important;
  font-size: 20px !important;
}

.testimonialCarousel {
  height: 140px !important;
  margin-top: 20px;
  cursor: default;
}

.silentbox-single {
  color: #4dc8ed;
  font-weight: bold;
  text-decoration: none !important;
}

.v-carousel__controls {
  background: rgba(0, 0, 0, 0) !important;
}

@media only screen and (max-width: 1400px) {
  .testimonialCarousel {
    height: 200px !important;
  }
}

@media only screen and (max-width: 1100px) {
  .supplierBtn,
  .supplierBtn p {
    font-size: 15px !important;
  }
  .wwSection {
    /* padding: 50px 0; */
  }
  .wwSection h4 {
    margin: 20px 0;
  }
  .wwSection div {
    line-height: 2.5;
  }
}

@media only screen and (max-width: 730px) {
  .businessLogo {
    width: 280px !important;
    left: 50%;
    top: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }
  .testimonialCarousel {
    height: 230px !important;
  }
  .sectionHeader {
    text-align: center;
  }
}

@media only screen and (max-width: 460px) {
  .testimonialCarousel {
    height: 270px !important;
  }
  .telNum {
    font-size: 17px !important;
  }
}

@media only screen and (max-width: 390px) {
  .testimonialCarousel {
    height: 380px !important;
  }
  .contributionIcon {
    font-size: 50px !important;
  }
  .contributionSection h3,
  .contributionSection p {
    font-size: 20px !important;
    text-align: left;
  }
}

#silentbox-overlay__description {
  color: #4dc8ed !important;
  font-family: Gotham !important;
  background: white;
  padding-bottom: 10px;
  border: 1px solid rgb(77, 200, 237);
  font-size: 20pt !important;
}

.profilePictureTitle {
  color: #162c47;
  font-weight: bold;
  text-align: center;
}
</style>
